import { getSameAttribute } from '@/utils/handleData.js'
import {
  setCheckButtons,
  setTableButtons,
  getStepFormBottomButtons
} from '@/utils/getbuttons.js'
import { daysFormat, getStringTime } from '@/filters/index'

const goodsOutbound = {
  name: 'goodsOutbound',
  title: '物资领用明细列表',
  size: '70%',
  direction: 'btt',
  maxheight: '450px',
  getParentFun: 'material/getGoodsList',
  getListFun: 'material/getGoodsOutbound',
  deleteFun: (params) => {
    return params.pageStatus === 'edit' ? 'material/deleteGoodsOutbound' : null
  },
  detailPage: [
    {
      buttonNames: ['生成领用单', '编辑领用单'],
      name: 'useReport',
      type: 'dialogForm',
      pageStatus: (params) => {
        return params.pageStatus === 'generate' ? 'add' : 'edit'
      }
    }
  ],
  headButtons: (params) => {
    return params.pageStatus === 'generate'
      ? setCheckButtons(['生成领用单'])
      : params.pageStatus === 'edit'
      ? setCheckButtons(['更新领用明细', '编辑领用单'])
      : null
  },
  tagInfo: (params) => {
    const useAmount = getSameAttribute(
      params.state.material.goodsOutbound,
      'useAmount'
    ).addValue
    return params.pageStatus === 'generate'
      ? '当前列表有' +
          params.getters['material/compileOutbound'].length +
          '种物资出库，出库数量默认为选择入库数据对应的理论库存数量，合计出库金额为：' +
          useAmount +
          '元，带“*”列数据必填，请修改完善并确认后再生成物资领用单；点击“分批”按钮可以拆分数据分不同保管人或用途登记领用'
      : '当前列表为编号' +
          params.state.material.curUseReport.useReportNo +
          '的物资领用单；合计出库金额为：' +
          useAmount +
          '元'
  },
  rowData: (params) => {
    return params.getters['material/compileOutbound']
  },
  columns: (params) => {
    var columns = [
      {
        prop: 'label',
        label: '\xa0\xa0物资编号/名称&&入库日期',
        width: '300px',
        align: 'left'
      },
      {
        prop: 'model',
        label: '规格型号'
      },
      {
        prop: 'goodsType',
        label: '物资类型',
        formItem: {
          type: 'cascader',
          options: params.state.dictionarys.goodsType,
          showAllLevels: false,
          disabled: true
        }
      },
      {
        prop: 'unit',
        label: '单位'
      },
      {
        prop: 'price',
        label: '单价(元)'
      },
      {
        prop: 'inboundQuantity',
        label: '入库数量'
      },
      {
        prop: 'totalUsed',
        label: '已领用数量'
      },
      {
        prop: 'useQuantity',
        label: '*出库数量',
        formItem: (params) => {
          return (row) => {
            return !row.children && params.pageStatus !== 'check'
              ? {
                  type: 'input'
                }
              : null
          }
        },
        number: true,
        isIdeal: () => {
          return (row) => {
            return row.useQuantity > row.inboundQuantity - row.totalUsed
              ? false
              : true
          }
        }
      },
      {
        prop: 'useAmount',
        label: '出库金额(元)',
        width: '120px'
      },
      {
        prop: 'keeper',
        label: '现场保管人',
        width: '120px',
        formItem: (params) => {
          return (row) => {
            return !row.children && params.pageStatus !== 'check'
              ? {
                  type: 'select',
                  options: (params) => {
                    return params.state.contractor.managePersonNames
                  },
                  filterable: true,
                  create: true,
                  placeholder:
                    row.goodsType[1] === '安全标志标牌' ? '该项必填' : ''
                }
              : null
          }
        }
      },
      {
        prop: 'purpose',
        label: '用途',
        formItem: (params) => {
          return (row) => {
            return !row.children && params.pageStatus !== 'check'
              ? {
                  type: 'input',
                  placeholder:
                    row.goodsType[0] === '危险化学品' ? '该项必填' : ''
                }
              : null
          }
        },
        width: '260px'
      }
    ]
    if (params.pageStatus !== 'check') {
      columns.push({
        label: '操作',
        buttons: (params) => {
          return (row) => {
            return !row.children
              ? params.pageStatus === 'edit'
                ? setTableButtons(['删除'])
                : setTableButtons(['分批', '删除'])
              : null
          }
        },
        width: '160px'
      })
    }
    return columns
  }
}

const useReport = {
  name: 'useReport',
  title: (params) => {
    return params.pageStatus === 'add' ? '新增物资领用单' : '编辑物资领用单'
  },
  manualUpload: true,
  addFun: 'material/addUseReport',
  editFun: 'material/editUseReport',
  getParentFun: 'material/getUseReport',
  formParams: {
    uid: '',
    orgUid: (params) => {
      return params.orgValue
    },
    useAmount: (params) => {
      return getSameAttribute(params.state.material.goodsOutbound, 'useAmount')
        .addValue
    },
    useReportNo: () => {
      return 'LYD' + getStringTime(new Date())
    },
    grantPerson: '',
    usePerson: '',
    useDepartment: '',
    useDate: daysFormat(new Date()),
    usePosition: '',
    usePhotos: [],
    useDetails: (params) => {
      return params.state.material.goodsOutbound
    },
    fileLists: {
      usePhotos: []
    }
  },
  formRules: {
    grantPerson: [
      {
        required: true,
        message: '请选择发放人',
        trigger: 'change'
      }
    ],
    usePerson: [
      {
        required: true,
        message: '请选择领用人',
        trigger: 'change'
      }
    ],
    useDepartment: [
      {
        required: true,
        message: '请选择领用部门',
        trigger: 'change'
      }
    ],
    usePosition: [
      {
        required: true,
        message: '请选择使用部位',
        trigger: 'change'
      }
    ]
  },
  formData: [
    {
      key: 'useReportNo',
      label: '领用单编号',
      type: 'input',
      readonly: true
    },
    {
      key: 'useAmount',
      label: '出库总金额',
      type: 'input',
      readonly: true,
      inputButton: '元'
    },
    {
      key: 'grantPerson',
      label: '发放人',
      type: 'select',
      options: (params) => {
        return params.state.contractor.managePersonNames
      },
      filterable: true,
      create: true
    },
    {
      key: 'usePerson',
      label: '领用人',
      type: 'select',
      options: (params) => {
        return params.state.contractor.managePersonNames
      },
      filterable: true,
      create: true
    },
    {
      key: 'useDepartment',
      label: '领用部门',
      type: 'select',
      options: (params) => {
        return params.orgFields.department && params.orgFields.department[0]
          ? params.orgFields.department[0].children
          : []
      },
      filterable: true,
      create: true
    },
    {
      key: 'usePosition',
      label: '使用部位',
      type: 'cascader',
      options: (params) => {
        return params.state.division.subitemList
      },
      placeholder: '可任选一个级别选项',
      filterable: true,
      checkStrictly: true,
      showAllLevels: false,
      emitPath: false
    },
    {
      key: 'usePhotos',
      label: '领用附件',
      type: 'upload',
      autoUpload: false,
      limit: 4,
      span: 24
    }
  ]
}

const goodsInbound = {
  name: 'goodsInbound',
  title: '物资验收单明细列表',
  size: '70%',
  getParentFun: (params) => {
    return params.step === 'materialGoodsList' ? 'material/getGoodsList' : null
  },
  detailPage: [
    {
      codes: ['generate'],
      name: 'goodsReceipt',
      type: 'stepForm',
      step: 'goodsReceiptInfo',
      theme: 'materialManage',
      label: '生成物资验收单',
      pageStatus: 'add'
    }
  ],
  maxheight: (params) => {
    return params.pageStatus === 'check' ? '530px' : '460px'
  },
  headButtons: (params) => {
    return params.pageStatus === 'generate'
      ? setCheckButtons(['生成验收单'])
      : null
  },
  tagInfo: (params) => {
    const inboundAmount = getSameAttribute(
      params.state.material.goodsInbound,
      'inboundAmount'
    ).addValue
    const isZero = params.state.material.goodsInbound.filter((item) => {
      return !item.price
    })
    return params.state.material.goodsInbound[0]
      ? '当前列表为' +
          params.state.material.goodsInbound[0].supplier +
          '物资入库明细；合计入库金额为：' +
          inboundAmount +
          '元，其中' +
          isZero.length +
          '条单价为0元，请修改完善并确认后再生成物资验收单'
      : ''
  },
  rowData: (params) => {
    return params.state.material.goodsInbound
  },
  columns: (params) => {
    var columns = [
      {
        prop: 'goods',
        label: '物资编号/名称',
        width: '300px'
      },
      {
        prop: 'model',
        label: '规格型号'
      },
      {
        prop: 'goodsType',
        label: '物资类型',
        formItem: {
          type: 'cascader',
          options: params.state.dictionarys.goodsType,
          showAllLevels: false,
          disabled: true
        }
      },
      {
        prop: 'unit',
        label: '单位'
      },
      {
        prop: 'price',
        label: '*单价(元)',
        formItem: {
          type: 'input',
          readonly: params.pageStatus === 'check' ? true : false
        },
        number: 2,
        isIdeal: () => {
          return (row, column) => {
            return row[column.prop] ? true : false
          }
        }
      },
      {
        prop: 'checkQuantity',
        label: '验收数量'
      },
      {
        prop: 'unqualified',
        label: '不合格品数量'
      },
      {
        prop: 'inboundQuantity',
        label: '入库数量'
      },
      {
        prop: 'inboundAmount',
        label: '入库金额(元)',
        number: true
      }
    ]
    return columns
  }
}

const materialManage = {
  pageTabs: [
    {
      label: '物资出入库',
      theme: 'materialManage',
      step: 'materialGoodsList',
      stepLabel: '物资出入库列表',
      checkFun: 'material/getGoodsList'
    }
  ],
  materialGoods: {
    name: 'materialGoods',
    theme: '物资出入库列表',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'drawerTable',
      'dialogForm',
      'dialogTable'
    ],
    headButtons: (params) => {
      return params.getters['user/orgBuildType'] === '总承包单位'
        ? setCheckButtons(['入库登记', '生成验收单', '生成领用单', '验收单管理', '领用单管理'])
        : setCheckButtons(['验收单管理', '领用单管理'])
    },
    getListFun: 'material/getGoodsList',
    deleteFun: 'material/deleteGoodsInbound',
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      projectUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      goodsType: '',
      supplier: '',
      inboundDate: [],
      query: ''
    },
    selectData: [
      {
        key: 'projectUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true
      },
      {
        key: 'goodsType',
        label: '物资类型',
        type: 'cascader',
        options: (params) => {
          return params.state.dictionarys.goodsType
            ? params.state.dictionarys.goodsType
            : []
        },
        placeholder: '可任选一个级别选项',
        filterable: true,
        checkStrictly: true,
        showAllLevels: false,
        emitPath: false
      },
      {
        key: 'supplier',
        label: '供应商',
        type: 'select',
        options: (params) => {
          return params.state.contractor.supplier
        },
        filterable: true,
        create: true
      },
      {
        key: 'inboundDate',
        label: '入库时间',
        type: 'time',
        timetype: 'daterange'
      },
      {
        key: 'query',
        label: '关键字',
        type: 'input',
        placeholder: '物资编号/物资名称/规格型号'
      }
    ],
    detailPage: [
      {
        buttonName: '入库登记',
        type: 'tables',
        name: 'goodsInbound',
        step: 'goodsInboundList',
        theme: 'materialManage',
        label: '物资入库登记列表'
      },
      {
        buttonName: '生成验收单',
        type: 'drawerTable',
        name: 'goodsInbound',
        expandAll: true
      },
      {
        buttonName: '生成领用单',
        type: 'drawerTable',
        name: 'goodsOutbound',
        expandAll: true
      },
      {
        buttonName: '验收单管理',
        type: 'tables',
        name: 'checkReports',
        theme: 'materialManage',
        step: 'checkReportsList',
        label: '物资验收单列表',
        checkType: 'checkByQuery',
        checkFun: 'material/getGoodsReceipt'
      },
      {
        buttonName: '领用单管理',
        type: 'tables',
        name: 'useReports',
        theme: 'materialManage',
        step: 'useReportsList',
        label: '物资领用单列表',
        checkType: 'checkByQuery',
        checkFun: 'material/getUseReport',
        expandAll: true
      },
      {
        codes: ['checkQuantity', 'inboundQuantity', 'checkStatus'],
        name: () => {
          return (params) => {
            return params.row && params.row.checkInfo
              ? 'inboundCheck'
              : 'materialGoods'
          }
        },
        type: () => {
          return (params) => {
            return params.row && params.row.checkInfo ? 'stepForm' : 'expand'
          }
        },
        pageStatus: () => {
          return (params) => {
            return params.row && params.row.checkInfo ? 'edit' : ''
          }
        },
        checkType: () => {
          return (params) => {
            return params.row && params.row.checkInfo ? 'useRowData' : ''
          }
        },
        step: 'inboundCheckInfo',
        theme: 'materialManage',
        label: '编辑物资入库明细'
      }
    ],
    selectColumn: true,
    tagInfo:
      '点击验收数量可编辑物资入库明细；点击出库数量可编辑领用单明细；勾选有剩余库存的入库物资明细后点击“生成领用单”可生成物资领用单',
    rowData: (params) => {
      return params.getters['material/goodsLevelList']
    },
    columns: [
      {
        width: '300px',
        align: 'left',
        prop: 'label',
        label: '物资编号/名称&&供应商名称&&入库日期'
      },
      {
        prop: 'goodsTypes',
        label: '物资类型&&规格型号'
      },
      { width: '', prop: 'unit', label: '单位' },
      { width: '', prop: 'price', label: '单价' },
      { width: '', prop: 'acceptanceStatus', label: '验收状态' },
      {
        width: '',
        drillDown: true,
        prop: 'checkQuantity',
        label: '验收数量',
        tooltip: {
          tipKey: 'checkInfo'
        }
      },
      {
        width: '',
        drillDown: true,
        prop: 'unqualified',
        label: '不合格数量'
      },
      {
        width: '',
        drillDown: true,
        prop: 'inboundQuantity',
        label: '入库数量'
      },
      { width: '', drillDown: true, prop: 'totalUsed', label: '出库数量' },
      {
        width: '',
        drillDown: true,
        prop: 'theoreticalInventory',
        label: '理论库存'
      },
      {
        label: '操作',
        buttons: setTableButtons(['删除'])
      }
    ],
    goodsInbound: goodsInbound,
    goodsOutbound: goodsOutbound,
    useReport: useReport
  },
  goodsInbound: {
    name: 'goodsInbound',
    title: '物资入库登记列表',
    componentTypes: ['navigate', 'check', 'tables'],
    checkType: 'add',
    saveFun: (params) => {
      return params.pageStatus === 'add'
        ? 'material/addGoodsInbound'
        : 'material/editGoodsInbound'
    },
    getParentFun: 'material/getGoodsList',
    detailPage: [
      {
        buttonName: '编辑',
        name: 'inboundCheck',
        type: 'stepForm',
        checkType: 'useRowData',
        step: 'inboundCheckInfo',
        theme: 'materialManage',
        label: '编辑物资入库明细'
      }
    ],
    headButtons: (params) => {
      return params.pageStatus === 'add'
        ? setCheckButtons(['保存', '导入明细', '下载导入模板'])
        : setCheckButtons(['保存'])
    },
    queryParams: (params) => {
      var queryParams =
        params.pageStatus === 'add'
          ? {
              orgUid: params.orgValue,
              checkResult: '0',
              inboundDate: daysFormat(new Date()),
              checkDate: daysFormat(new Date()),
              unqualified: 0
            }
          : null
      return queryParams
    },
    selectData: (params) => {
      var selectData =
        params.pageStatus === 'add'
          ? [
              {
                key: 'goods',
                label: '物资名称规格',
                type: 'select',
                options: params.state.material.goods,
                filterable: true,
                multiple: true,
                placeholder:
                  '请批量选择要登记入库的物资名称及规格型号；如没有可手动输入添加，物资名称及规格型号用“/”分开；选择物资后添加前可展开选项录入共性信息',
                checkByValue: true,
                create: true,
                span: 24
              },
              {
                key: 'goodsType',
                label: '物资类型',
                type: 'cascader',
                options: (params) => {
                  return params.state.dictionarys.goodsType
                    ? params.state.dictionarys.goodsType
                    : []
                },
                filterable: true
              },
              {
                key: 'checkPerson',
                label: '验收人',
                type: 'select',
                options: params.state.contractor.managePersonNames,
                filterable: true,
                create: true
              },
              {
                key: 'supplier',
                label: '供货商',
                type: 'select',
                options: params.state.contractor.supplier,
                filterable: true,
                create: true
              },
              {
                key: 'storageWarehouse',
                label: '存储仓库',
                type: 'input'
              }
            ]
          : null
      return selectData
    },
    tagInfo: (params) => {
      return params.pageStatus === 'add'
        ? '请批量导入入库明细或通过在表头表单中批量选择物资名称，并选择录入共性的入库信息，然后点击“添加”按钮多次批量生成入库清单，在列表中修改个性指标后保存，表头名称中加“*”的为必填项'
        : '当前列表明细已入库成功，修改列表数据点击“保存”按钮可批量编辑入库信息；点击行“编辑”按钮可单条编辑更多入库信息'
    },
    rowData: (params) => {
      return params.state.material.goodsInbound
    },
    columns: [
      {
        prop: 'goods',
        label: '*物资编号/名称',
        width: '240px',
        formItem: (params) => {
          return params.pageStatus === 'add'
            ? {
                type: 'select',
                options: params.state.material.goods,
                filterable: true,
                checkByValue: true,
                create: true
              }
            : null
        }
      },
      {
        prop: 'model',
        label: '规格型号',
        formItem: {
          type: 'input'
        }
      },
      {
        prop: 'goodsType',
        label: '*物资类型',
        formItem: {
          type: 'cascader',
          options: (params) => {
            return params.state.dictionarys.goodsType
              ? params.state.dictionarys.goodsType
              : []
          },
          filterable: true,
          emitPath: true,
          showAllLevels: false
        }
      },
      {
        prop: 'supplier',
        label: '*供货商',
        width: '200px',
        formItem: {
          type: 'select',
          options: () => {
            return []
          },
          filterable: true,
          create: true
        }
      },
      {
        prop: 'unit',
        label: '*单位',
        width: '100px',
        formItem: {
          type: 'select',
          options: (params) => {
            return params.dictionarys.unit
          },
          filterable: true,
          create: true
        }
      },
      {
        prop: 'price',
        label: '单价(元)',
        width: '100px',
        formItem: {
          type: 'input'
        },
        number: 2
      },
      {
        prop: 'checkQuantity',
        label: '*验收数量',
        formItem: {
          type: 'input'
        },
        number: true
      },
      {
        prop: 'checkPerson',
        label: '*现场验收人',
        formItem: {
          type: 'select',
          options: (params) => {
            return params.state.contractor.managePersonNames
          },
          filterable: true,
          create: true
        }
      },
      {
        prop: 'checkResult',
        label: '验收结果',
        width: '220px',
        formItem: {
          type: 'select',
          options: (params) => {
            return params.dictionarys.checkResult
          },
          checkByValue: true
        }
      },
      {
        prop: 'storageWarehouse',
        label: '*储存仓库',
        width: '160px',
        formItem: {
          type: 'input'
        }
      },
      {
        label: '操作',
        buttons: (params) => {
          return params.pageStatus === 'add'
            ? setTableButtons(['删除'])
            : setTableButtons(['编辑'])
        },
        width: '100px'
      }
    ],
    hasPagination: false
  },
  inboundCheck: {
    name: 'inboundCheck',
    componentTypes: ['navigate', 'stepForm', 'dialogTable'],
    editArray: true,
    manualUpload: true,
    editFun: 'material/editGoodsInbound',
    getParentFun: 'material/getGoodsList',
    formParams: {
      uid: '',
      model: '',
      unit: '',
      price: '',
      goodsType: [],
      checkQuantity: 0,
      checkResult: '0',
      unqualified: 0,
      inboundQuantity: 0,
      storageWarehouse: '',
      checkDate: '',
      checkPerson: '',
      checkContent: [],
      fileLists: {
        checkContent: []
      }
    },
    formRules: {
      goodsType: [
        {
          required: true,
          message: '请选择物资类型',
          trigger: 'change'
        }
      ],
      unit: [
        {
          required: true,
          message: '请输入或选择单位',
          trigger: 'change'
        }
      ],
      checkQuantity: [
        {
          required: (params) => {
            return params.formValues && !params.formValues.checkQuantity
          },
          message: '请输入不为0的验收数量'
        }
      ],
      checkPerson: [
        {
          required: true,
          message: '请输入或选择验收人员',
          trigger: 'change'
        }
      ],
      checkResult: [
        {
          required: true,
          message: '请选择验收结果',
          trigger: 'change'
        }
      ],
      unqualified: [
        {
          required: (params) => {
            return params.formValues && params.formValues.checkResult === '2'
          },
          message: '验收结果有不合格品时，必须输入不合格品数量',
          trigger: 'blur'
        }
      ],
      storageWarehouse: [
        {
          required: true,
          message: '请输入储存仓库',
          trigger: 'blur'
        }
      ]
    },
    formData: {
      card: '物资入库验收明细',
      manualUpload: true,
      bottomButtons: getStepFormBottomButtons(3),
      fields: [
        {
          key: 'goods',
          label: '物资编号/名称',
          type: 'input',
          disabled: true
        },
        {
          key: 'model',
          label: '规格型号',
          type: 'input'
        },
        {
          key: 'goodsType',
          label: '物资类型',
          type: 'cascader',
          options: (params) => {
            return params.state.dictionarys.goodsType
              ? params.state.dictionarys.goodsType
              : []
          },
        filterable: true,
        emitPath: true
        },
        {
          key: 'supplier',
          label: '供货商',
          type: 'input',
          disabled: true
        },
        {
          key: 'unit',
          label: '单位',
          type: 'select',
          options: (params) => {
            return params.dictionarys.unit
          },
          filterable: true,
          create: true
        },
        {
          key: 'price',
          label: '单价(元)',
          type: 'input',
          number: 2
        },
        {
          key: 'checkQuantity',
          label: '验收数量',
          type: 'input',
          number: true
        },
        {
          key: 'unqualified',
          label: '不合格品数量',
          type: 'input',
          number: true
        },
        {
          key: 'inboundQuantity',
          label: '入库数量',
          type: 'input',
          disabled: true
        },
        {
          key: 'storageWarehouse',
          label: '储存仓库',
          type: 'input'
        },
        {
          key: 'inboundDate',
          label: '入库时间',
          type: 'time',
          disabled: true
        },
        {
          key: 'checkDate',
          label: '验收时间',
          type: 'time'
        },
        {
          key: 'checkPerson',
          label: '现场验收人',
          type: 'select',
          options: (params) => {
            return params.state.contractor.managePersonNames
          },
          filterable: true,
          create: true
        },
        {
          key: 'checkResult',
          label: '验收结果',
          type: 'select',
          options: (params) => {
            return params.dictionarys.checkResult
          },
          checkByValue: true
        },
        {
          key: 'checkContent',
          label: '验收附件',
          type: 'upload',
          autoUpload: false,
          limit: 4,
          span: 24
        }
      ]
    }
  },
  useReports: {
    name: 'useReports',
    theme: '物资领用单列表',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'drawerTable',
      'dialogForm'
    ],
    getListFun: 'material/getUseReport',
    deleteFun: 'material/deleteUseReport',
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      projectUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      useStartDate: '',
      usePosition: '',
      query: '',
      useEndDate: ''
    },
    selectData: [
      {
        key: 'projectUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true
      },
      {
        key: 'usePosition',
        label: '使用部位',
        type: 'cascader',
        options: (params) => {
          return params.state.division.subitemList
        },
        placeholder: '可任选一个级别选项',
        filterable: true,
        checkStrictly: true,
        showAllLevels: false,
        emitPath: false
      },
      {
        key: 'useDate',
        label: '领用时间',
        type: 'time',
        timetype: 'daterange'
      },
      {
        key: 'query',
        label: '关键字',
        type: 'input',
        placeholder: '领用人/发放人/领用部门/使用部位'
      }
    ],
    detailPage: [
      {
        codes: ['edit', 'check'],
        type: 'drawerTable',
        name: 'goodsOutbound',
        checkType: 'checkByUid',
        checkFun: 'material/getGoodsOutbound',
        expandAll: true
      }
    ],
    rowData: (params) => {
      return params.state.material.useReport
    },
    columns: [
      {
        width: '',
        prop: 'useReportNo',
        label: '物资领用单编号'
      },
      {
        prop: 'useDate',
        label: '领用日期'
      },
      { width: '', prop: 'usePerson', label: '领用人' },
      { width: '', prop: 'grantPerson', label: '发放人' },
      {
        width: '460px',
        prop: 'usePosition',
        label: '使用部位'
      },
      {
        width: '',
        prop: 'useDepartment',
        label: '领用部门'
      },
      {
        width: '',
        prop: 'useAmount',
        label: '出库金额(元)'
      },
      {
        label: '操作',
        width: '220px',
        buttons: (params) => {
          return params.getters['user/orgBuildType'] === '总承包单位'
            ? setTableButtons(['编辑', '删除', '附件'])
            : setCheckButtons(['明细', '附件'])
        }
      }
    ],
    goodsOutbound: goodsOutbound,
    useReport: useReport
  },
  goodsReceipt: {
    name: 'goodsReceipt',
    componentTypes: ['navigate', 'stepForm'],
    addFun: 'material/addGoodsReceipt',
    getParentFun: 'material/getGoodsReceipt',
    formParams: {
      uid: '',
      orgUid: (params) => {
        return params.orgValue
      },
      receiptNo: () => {
        return 'YSD' + getStringTime(new Date())
      },
      useType: '安全物资采购',
      supplier: (params) => {
        const first =
          params.state.material.goodsInbound &&
          params.state.material.goodsInbound[0]
        return first ? first.supplier : ''
      },
      useReason: '',
      useDate: daysFormat(new Date()),
      useAmount: (params) => {
        return getSameAttribute(
          params.state.material.goodsInbound,
          'inboundAmount'
        ).addValue
      },
      useDepartment: '',
      usePerson: '',
      approver: '',
      detailUids: (params) => {
        return (params.state.material.goodsInbound || []).map((item) => {
          return item.uid
        })
      }
    },
    formRules: {
      useType: [
        {
          required: true,
          message: '请选择物资类型',
          trigger: 'change'
        }
      ],
      supplier: [
        {
          required: true,
          message: '请输入供货商',
          trigger: 'blur'
        }
      ],
      useReason: [
        {
          required: true,
          message: '请输入采购原因',
          trigger: 'blur'
        }
      ],
      useDate: [
        {
          required: true,
          message: '请选择验收时间',
          trigger: 'change'
        }
      ],
      useDepartment: [
        {
          required: true,
          message: '请输入或选择采购部门',
          trigger: 'change'
        }
      ],
      usePerson: [
        {
          required: true,
          message: '请输入或选择采购人',
          trigger: 'change'
        }
      ],
      approver: [
        {
          required: true,
          message: '请输入或选择审批人',
          trigger: 'change'
        }
      ]
    },
    formData: {
      card: '物资验收单',
      bottomButtons: getStepFormBottomButtons(3),
      fields: [
      {
        key: 'receiptNo',
        label: '验收单编号',
        type: 'input',
        readonly: true
      },
      {
        key: 'useType',
        label: '物资类型',
        type: 'select',
        options: [
          { value: '安全物资采购', label: '安全物资采购' },
          { value: '工程物资采购', label: '工程物资采购' }
        ]
      },
      {
        key: 'supplier',
        label: '供货商',
        type: 'input'
      },
      {
        key: 'useReason',
        label: '采购原因',
        type: 'input'
      },
      {
        key: 'useDate',
        label: '验收时间',
        type: 'time'
      },
      {
        key: 'useAmount',
        label: '验收总金额(元)',
        type: 'input',
        readonly: true
      },
      {
        key: 'useDepartment',
        label: '采购部门',
        type: 'select',
        options: (params) => {
          return params.orgFields.department &&
            params.orgFields.department[0]
            ? params.orgFields.department[0].children
            : []
        },
        filterable: true,
        create: true
      },
      {
        key: 'usePerson',
        label: '采购人',
        type: 'select',
        options: (params) => {
          return params.state.contractor.managePersonNames
        },
        filterable: true,
        create: true
      },
      {
        key: 'approver',
        label: '审批人',
        type: 'select',
        options: (params) => {
          return params.state.contractor.managePersonNames
        },
        filterable: true,
        create: true
      }
      ]
    }
  },
  checkReports: {
    name: 'checkReports',
    theme: '物资验收单列表',
    componentTypes: ['navigate', 'check', 'tables', 'drawerTable'],
    getListFun: 'material/getGoodsReceipt',
    deleteFun: 'material/deleteGoodsReceipt',
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      projectUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      }
    },
    selectData: [
      {
        key: 'projectUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true
      }
    ],
    detailPage: [
      {
        buttonName: '明细',
        type: 'drawerTable',
        name: 'goodsInbound',
        checkType: 'checkByRow',
        checkFun: 'material/getGoodsList',
        pageStatus: 'check'
      }
    ],
    tagInfo: '当前列表为物资验收单列表，点击“明细”可查看该验收单对应的入库明细',
    rowData: (params) => {
      return params.state.material.receiptList
    },
    columns: [
      { prop: 'receiptNo', label: '验收单编号', width: '200px' },
      { prop: 'useReason', label: '采购原因', width: '220px' },
      { prop: 'useDate', label: '验收时间' },
      { prop: 'useAmount', label: '采购金额(元)' },
      { prop: 'useDepartment', label: '采购部门' },
      { prop: 'usePerson', label: '采购人' },
      { prop: 'approver', label: '审批人' },
      { prop: 'useType', label: '物资类型' },
      {
        label: '操作',
        buttons: setTableButtons(['明细', '删除']),
        width: '180px'
      }
    ],
    goodsInbound: goodsInbound
  }
}

export default materialManage
